
exports.webRemOption = {
  rootValue: 24,
  minPixelValue: 1.01
}

exports.mobileRemOption = {
  rootValue: 80,
  minPixelValue: 2.01
}
